// Conversion events for Google Analytics / Google Ads, from the Bookalet widget.
//
// Bookalet's publish.js calls window.bookalet_bookingMade(details) and window.bookalet_enquiryMade(details)
// when a guest completes a booking or enquiry in the widget, and posts an "openModal" message when the
// booking form opens. We push them to the dataLayer for GTM to send to GA4 from this page, so they're attributed to the visit (and
// any ad click) that brought the guest here. No guest details are sent: only the value and booking reference.

const BOOKALET_ORIGIN = 'https://widgets.bookalet.co.uk';

// A plain dataLayer event: GTM's "Bookalet conversions" trigger picks these up and its GA4 event tag sends
// them on (gtag('event') calls are ignored by this container, so they must go through GTM).
function send(eventName, params = {}) {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: eventName, value: undefined, currency: undefined, transaction_id: undefined, ...params });
}

// Bookalet's payload shape isn't documented: pick the first numeric total-like field, if any.
function bookingValue(details) {
  if (!details || typeof details !== 'object') return undefined;
  const key = Object.keys(details).find((k) => /total|price|amount|value/i.test(k) && !isNaN(parseFloat(details[k])));
  return key ? parseFloat(details[key]) : undefined;
}

function bookingRef(details) {
  if (!details || typeof details !== 'object') return undefined;
  const key = Object.keys(details).find((k) => /ref|reference|bookingid|id$/i.test(k));
  return key ? String(details[key]) : undefined;
}

export function installBookaletTracking() {
  if (typeof window === 'undefined' || window.__figtreeBookingTracking) return;
  window.__figtreeBookingTracking = true;

  window.bookalet_bookingMade = (details) => {
    const value = bookingValue(details);
    send('booking_made', {
      currency: 'GBP',
      ...(value !== undefined && { value }),
      ...(bookingRef(details) && { transaction_id: bookingRef(details) }),
    });
  };

  window.bookalet_enquiryMade = () => send('enquiry_made');

  let started = false;
  window.addEventListener('message', (e) => {
    if (e.origin !== BOOKALET_ORIGIN || started) return;
    if (String(e.data).split('|')[1] === 'openModal') {
      started = true; // once per page view
      send('booking_start');
    }
  });
}
